import BaseState from "Engine/base/states/BaseState";

export default class JackpotGameIdleState extends BaseState {

    constructor(stateData) {
        super(stateData);
    }

}
